import { config } from "../../../config/config";

export interface NotificationOutput {
  publicId: string;
  type: string;
  title: string;
  message: string;
  metadata: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

export interface GetNotificationsResponse {
  notifications: NotificationOutput[];
  total: number;
}

export interface UnreadCountResponse {
  count: number;
}

const authHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export const getNotificationsRequest = async (
  token: string,
  params: {
    limit?: number;
    offset?: number;
    type?: string;
    unreadOnly?: boolean;
  },
): Promise<GetNotificationsResponse> => {
  const qp = new URLSearchParams();
  if (params.limit !== undefined) qp.append("limit", params.limit.toString());
  if (params.offset !== undefined)
    qp.append("offset", params.offset.toString());
  if (params.type) qp.append("type", params.type);
  if (params.unreadOnly) qp.append("unreadOnly", "true");

  const response = await fetch(
    `${config.API_URL}/notifications?${qp.toString()}`,
    { headers: authHeaders(token) },
  );
  if (!response.ok) {
    throw new Error("Error al obtener notificaciones");
  }
  return response.json() as Promise<GetNotificationsResponse>;
};

export const getUnreadCountRequest = async (
  token: string,
): Promise<UnreadCountResponse> => {
  const response = await fetch(`${config.API_URL}/notifications/unread-count`, {
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error("Error al obtener conteo de notificaciones");
  }
  return response.json() as Promise<UnreadCountResponse>;
};

export const markAsReadRequest = async (
  token: string,
  publicId: string,
): Promise<void> => {
  const response = await fetch(
    `${config.API_URL}/notifications/${publicId}/read`,
    { method: "PATCH", headers: authHeaders(token) },
  );
  if (!response.ok) {
    throw new Error("Error al marcar notificación como leída");
  }
};

export const markAllAsReadRequest = async (
  token: string,
): Promise<{ count: number }> => {
  const response = await fetch(`${config.API_URL}/notifications/read-all`, {
    method: "PATCH",
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error("Error al marcar todas como leídas");
  }
  return response.json() as Promise<{ count: number }>;
};
